import * as React from 'react';
import './index.scss';
import { StageDefault } from '@/context.ts';
const { useEffect, useState, useContext } = React;
const Tab3: React.FC = () => {
  const [current, Current] = useState<number>(0);
  return (
    <div
      className='tab3'
    >
      <div className={current === 0 ? 'web-rule-1 on1' : 'web-rule-1 on2'}>
        <div className='web-groupTab'>
          {
            ['金牌', '游戏/娱乐'].map((item: string, index: number) => (
              <div
                className={current === index ? 'groupTabItem on' : 'groupTabItem'}
                key={item}
                onClick={
                  () => {
                    Current(index);
                  }
                }
              >年度{item}公会</div>
            ))
          }
        </div>
        <img src={current === 0 ? 'https://diy-assets.msstatic.com/hyys/activity/20201112web-rule-1-1.png' : 'https://diy-assets.msstatic.com/hyys/activity/20201112web-rule-1-2.png'} />
      </div>
      {
        [
          'https://diy-assets.msstatic.com/hyys/activity/20201112web-rule-2.png',
          'https://diy-assets.msstatic.com/hyys/activity/20201112web-rule-3.png',
          'https://diy-assets.msstatic.com/hyys/activity/20201112web-rule-4.png',
          'https://diy-assets.msstatic.com/hyys/activity/20201112web-rule-5.png',
        ].map(item => {
          return <img className='ruleImg' src={item} />
        })
      }
    </div>
  )
}

export default Tab3;